const Sms = ({ width = 20, height = 20, color = 'currentColor' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26" fill="none">
      <path
        d="M18.4163 22.2087H7.58299C4.33299 22.2087 2.16632 20.5837 2.16632 16.792V9.20866C2.16632 5.41699 4.33299 3.79199 7.58299 3.79199H18.4163C21.6663 3.79199 23.833 5.41699 23.833 9.20866V16.792C23.833 20.5837 21.6663 22.2087 18.4163 22.2087Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.417 9.75L15.0262 12.4583C13.9103 13.3467 12.0795 13.3467 10.9637 12.4583L7.58368 9.75"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Sms;
